import React, { useMemo, useState } from "react";
import { AppPage, MimaButton, MimaTable, MimaText } from "../../../components";
import constant from "../../../utils/constant";
import moment from "moment";
import { amountFormatter } from "../../../utils/utils";
import { AnimatePresence } from "framer-motion";
import {
  CreateLimitContainer,
  UpdateLimitContainer,
} from "../../../containers";

const MoneyExLimit = ({
  onLimitChange,
  data,
  currentPage,
  setCurrentPage,
  limit,
  isLoading,
  isFetching,
  setSearchQuery,
  closeModal,
  createLimitModal,
  goToCreateLimit,
  goToUpdateLimit,
  updateLimitModal,
}) => {
  const [item, setItem] = useState({});

  const moneyExLimitTableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.moneyExLimits || [];
    }
    return [];
  }, [data]);

  const moneyExLimtTableColumns = [
    {
      Header: "Date Created",
      Cell: ({ cell }) => {
        const createdAt = cell.row.original.createdAt;
        return <span>{moment(createdAt).format("DD/MM/YYYY HH:MM a")}</span>;
      },
    },
    {
      Header: "Daily Limits",
      Cell: ({ cell }) => {
        const dailyLimit = cell.row.original.daily;

        return (
          <div>
            {dailyLimit.map((limit) => (
              <MimaText variant="small" mb={1}>
                {amountFormatter(limit.currencyCode).format(limit.value)}
              </MimaText>
            ))}
          </div>
        );
      },
    },
    {
      Header: "Weekly Limits",
      Cell: ({ cell }) => {
        const weeklyLimit = cell.row.original.weekly;

        return (
          <div>
            {weeklyLimit.map((limit) => (
              <MimaText variant="small" mb={1}>
                {amountFormatter(limit.currencyCode).format(limit.value)}
              </MimaText>
            ))}
          </div>
        );
      },
    },
    {
      Header: "Monthly Limits",
      Cell: ({ cell }) => {
        const monthlyLimit = cell.row.original.monthly;

        return (
          <div>
            {monthlyLimit.map((limit) => (
              <MimaText variant="small" mb={1}>
                {amountFormatter(limit.currencyCode).format(limit.value)}
              </MimaText>
            ))}
          </div>
        );
      },
    },
    {
      Header: "Grade",
      accessor: "grade",
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const item = cell.row.original;
        return (
          <span
            className="tableAction__text"
            onClick={() => {
              setItem(item);
              goToUpdateLimit();
            }}
          >
            Update Limit
          </span>
        );
      },
    },
  ];
  return (
    <AppPage pageTitle="Money-Ex Limits">
      <MimaButton
        title="Create Limit"
        onClick={goToCreateLimit}
        mt={1}
        mb={1}
      />
      <MimaTable
        tableData={moneyExLimitTableData}
        tableColumns={moneyExLimtTableColumns}
        searchPlaceholder="Search Money-Ex Limits"
        searchVariant="wide"
        totalItems={data?.data?.totalCounts}
        onLimitChange={onLimitChange}
        isLoading={isLoading}
        isFetching={isFetching}
        limit={limit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setSearchQuery={setSearchQuery}
      />
      {(createLimitModal || updateLimitModal) && (
        <div className="modal">
          <AnimatePresence>
            {createLimitModal && (
              <CreateLimitContainer closeModal={closeModal} item={item} />
            )}
            {updateLimitModal && (
              <UpdateLimitContainer closeModal={closeModal} item={item} />
            )}
          </AnimatePresence>
        </div>
      )}
    </AppPage>
  );
};

export default MoneyExLimit;
